import {useState,useContext, useRef,useEffect} from "react";
import { List } from "react-window";
import { fileKind } from "@clodo/core";
import { BrowserContext } from "./services/BrowserContext";
import Folder from "./files/Folder";
import File from "./files/File";
import Image from "./files/Image";
import Video from "./files/Video";
import Text from "./files/Text";
import Pdf from "./files/Pdf";

const ROW_HEIGHT = 54;

// Ligne virtualisée : le `style` (position absolue) fourni par react-window doit
// envelopper le contenu de la ligne.
const ItemRow = ({ index, style, items, renderItem }) => (
    <div style={style}>{renderItem(items[index])}</div>
);

const Content = ({elements,path,newFolder,handleNewFolder,renameItemName,isSearchFolder,limit,handleSearchLimit})=>{
    const [name,setName] = useState('New Folder') ;
    const handleName = (e) => setName(e.target.value);

    const {itemsManipulator} = useContext(BrowserContext);

    const valid = ()=>{
        const folderpath = Array.from(path);
        folderpath.push(name === "" ? "New Folder" : name);
        itemsManipulator.create(folderpath);
        handleNewFolder(false);
        setName("New Folder");
    }

    const submit = (e) => {
        if (e.key === 'Enter') {
            valid();
        }
    }
    const cancel = () => {
        setName("New Folder");
        handleNewFolder(false);
    }

    const seeMoreResult = () => {
        handleSearchLimit(50,true)
    }

    const newFolderInput = useRef(null);
    const cancelBtn = useRef(null);

    const onBlurNewFolder = (event)=>{
        if (cancelBtn.current && cancelBtn.current.contains(event.relatedTarget)) {
            return;
        }
        valid();
    }

    useEffect(() => {
        if(newFolder){
            newFolderInput.current.focus();
            newFolderInput.current.select();
        }
    },[newFolder]);

    // Dispatch d'un élément vers le composant de ligne. La reconnaissance du
    // type est dans @clodo/core (fileKind), partagée avec le mobile ; ne reste
    // ici que l'association type -> composant web.
    // element.path est le chemin parent (tamponné par showPath, ou fourni par la
    // recherche) ; à défaut on retombe sur `path` (dossier courant).
    const renderItem = (element) => {
        const itemPath = element.path || path;
        const commonProps = {
            path: itemPath,
            name: element.name,
            size: element.size,
            rename: renameItemName === element.name,
            shared: element.shared,
            shareToken: element.share_token,
            shareExpiresAt: element.share_expires_at
        };
        const dlProps = { dlExp: element.dl_exp, dlSig: element.dl_sig };
        switch (fileKind(element)) {
            case 'folder':
                return <Folder {...commonProps}/>
            case 'image':
                return <Image {...commonProps} {...dlProps}></Image>
            case 'video':
                return <Video {...commonProps} {...dlProps} jellyfinId={element.jellyfin_id} jfExp={element.jf_exp} jfSig={element.jf_sig}></Video>
            case 'text':
                return <Text {...commonProps} {...dlProps}></Text>
            case 'pdf':
                return <Pdf {...commonProps} {...dlProps}></Pdf>
            default:
                return <File {...commonProps}><File.Ico><i className="bi bi-file-earmark fs-4 me-1 text-dark"></i></File.Ico></File>
        }
    }

    const items = elements.child;
    const rowKey = (index) => {
        const el = items[index];
        return (el.path ? el.path.join('/') : '') + '/' + el.name;
    };

    return (
        <div style={{display:'flex', flexDirection:'column', height:'100%'}}>
        {
            newFolder ?
                <div className="list-group-item list-group-item-action justify-content-between d-flex align-items-center">
                <div className="d-flex align-items-center">
                    <i className="bi bi-folder-fill text-warning"></i>
                    <input ref={newFolderInput} type="text" value={name} className="form-control" onChange={handleName} onKeyUp={submit} onBlur={onBlurNewFolder}/>
                    <button ref={cancelBtn} onClick={cancel} className="bi bi-x text-danger fs-1 btn btn-link"></button>
                </div>
            </div> : ''
        }
        <div style={{flex:'1 1 auto', minHeight:0}}>
            <List
                rowComponent={ItemRow}
                rowCount={items.length}
                rowHeight={ROW_HEIGHT}
                rowKey={rowKey}
                rowProps={{ items, renderItem }}
            />
        </div>
        {
            isSearchFolder &&  items.length === limit ?
            <button className="list-group-item list-group-item-action justify-content-between d-flex align-items-center" onClick={seeMoreResult}>
                See more results...
            </button> : ''
        }
        </div>
    );
}
export default Content
